module.exports = __webpack_public_path__ + "static/media/aside-hot-line.02b3d1f8.png";